// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dqrZo","tabsBox":"styles_tabsBox__3RmJb","createButton":"styles_createButton__zaeZ0"};